// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_nj-0";
export var discountCodeInput = "_nj-1";